/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://fvk6ehanl5.execute-api.us-east-2.amazonaws.com/demo",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://db32434ltvafdafmg4chxdreqa.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-6rflzuuvpbbl3hzrmejimsljsa",
    "aws_cognito_identity_pool_id": "us-east-2:c71e72c0-1de9-4678-9400-27ff47981a2a",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_9qTTlFNrn",
    "aws_user_pools_web_client_id": "3lersf1v18llk1o7j2bqp0gcvq",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "tacotradeforms160726-demo",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "geo": {
        "amazon_location_service": {
            "region": "us-east-2",
            "search_indices": {
                "items": [
                    "placeindexfeb81bfc-demo"
                ],
                "default": "placeindexfeb81bfc-demo"
            }
        }
    }
};


export default awsmobile;
